import { Column } from 'primereact/column'
import React, { useEffect } from 'react'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import useZonaEntrega, { LOAD_MESSAGE } from './ZonaEntregaHook'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ZonaEntregaModal from './ZonaEntregaModal'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

function ZonaEntrega({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useZonaEntrega()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.loadZonasEntrega(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.19 - Cadastro Zona - Entregas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.onBtnNovo(selectedTp)} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.zonasEntrega}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                emptyMessage={'Não existe zonas de entrega cadastradas . . .'}
                globalFilter={state.globalFilter}
                paginator={true}
                rows={10}
                selectionMode="single"
                onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
              >
                <Column field="id" header="Código" style={tableCellCentered(80)} />
                <Column field="name" header="Nome" />
                <Column
                  field="cities"
                  header="Qtd. Cidades Selecionadas"
                  style={tableCellCentered(400)}
                  body={item => {
                    return item.cities.length
                  }}
                />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered(80)}
                  body={zonaEntrega => <CustomCheckbox checked={zonaEntrega.actived} />}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ZonaEntregaModal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ZonaEntrega))
